import { mfLogoBaseUrl } from '../../../env'
import { formatIndianNumberWithDecimals } from '../../../utils/FD/fd'
import RenderHTML from '../../ui-components/RenderHTML'

// Define interface for props
export interface InvestmentSummaryProps {
  bankName: string
  logoSrc: string
  interestRate: string
  tenure: string
  investingAmount: number
  maturityDate: string
  maturityAmount: number
}

export const InvestmentSummary = ({
  bankName,
  logoSrc,
  interestRate,
  tenure,
  investingAmount,
  maturityDate,
  maturityAmount
}: InvestmentSummaryProps) => {
  return (
    <div className='w-full backdrop-blur-[27px] text-white flex flex-col items-center relative'>
      <div className='rounded-t-[16px] bg-[#127FD1] border border-[#33A7E4] px-4 pt-5 pb-7 w-full flex items-center'>
        <img src={`${mfLogoBaseUrl}${logoSrc}`} alt={`${bankName} logo`} className='w-10 h-10 mr-3' />
        <div className='flex flex-col'>
          <span className='text-[13px] font-[400] text-[#D1ECFF]'>{bankName}</span>
          <span className='text-[14px]'>
            {interestRate} • {tenure}
          </span>
        </div>
      </div>

      <div className='border bg-[#1886D4] border-[#33A7E4] backdrop-blur-[27px] rounded-[16px] py-5 -mt-3 w-full text-center relative z-1'>
        <div className='text-[14px]'>Investing today</div>
        <div className='text-[28px] font-[500]'>₹{formatIndianNumberWithDecimals(investingAmount, 0)}</div>
      </div>

      <div className='w-full relative h-2 z-10 flex justify-center items-center'>
        <div className='border-[1.5px] border-[#33A7E4] bg-[#1B8BD7] rounded-[50%] p-2'>
          <RenderHTML innerHTMLText={summaryArrowIcon} />
        </div>
      </div>
      <div className='border border-[#33A7E4] bg-[#158BD8] text-[#A2FFA0] backdrop-blur-[27px] rounded-[16px] py-5 w-full text-center'>
        <div className='text-[14px]'>Matures on {maturityDate}</div>
        <div className='text-[28px] font-[500]'>~ ₹{formatIndianNumberWithDecimals(maturityAmount, 0)}</div>
      </div>
    </div>
  )
}

export const summaryArrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M6.53033 11.7803C6.23744 12.0732 5.76256 12.0732 5.46967 11.7803L0.696699 7.00736C0.403806 6.71447 0.403806 6.23959 0.696699 5.9467C0.989592 5.65381 1.46447 5.65381 1.75736 5.9467L6 10.1893L10.2426 5.9467C10.5355 5.65381 11.0104 5.65381 11.3033 5.9467C11.5962 6.23959 11.5962 6.71447 11.3033 7.00736L6.53033 11.7803ZM5.25 0.75C5.25 0.335787 5.58579 1.81058e-08 6 0C6.41421 -1.81058e-08 6.75 0.335787 6.75 0.75L5.25 0.75ZM6 11.25L5.25 11.25L5.25 0.75L6 0.75L6.75 0.75L6.75 11.25L6 11.25Z" fill="white"/>
</svg>`
